import {HoldStatus} from '@store/holds/holds.types';
import {ActiveHoldCountsByStatus, CardLoginValue} from '@store/patron/patron.types';
import {isObject, isPopulatedString} from '@aviary/store/common/typing.helpers';
import {containsApiErrorCode, isHttpErrorResponse} from '@store/common/effects.helpers';

export function calculateTotalHoldCountsFor(statuses: readonly HoldStatus[], countsByStatus: ActiveHoldCountsByStatus): number {
  return statuses.reduce((accumulator, status) => accumulator + countsByStatus[status], 0);
}

export function isCardLogin(thing: unknown): thing is CardLoginValue {
  return isObject(thing) && isPopulatedString(thing['cardNumber']) && isPopulatedString(thing['pin']);
}

export function isIncorrectCurrentPinFailure(error: unknown): boolean {
  return isHttpErrorResponse(error) && containsApiErrorCode('PATRON_CURRENT_PIN_INCORRECT', error);
}

export function isPinChangeLockedFailure(error: unknown): boolean {
  return isHttpErrorResponse(error) && containsApiErrorCode('PATRON_PIN_CHANGE_LOCKED', error);
}
